// Page « Membres » de l'administration masquée (Louka, 08/10) : l'application est la source des
// comptes (elle pousse toute la liste toutes les 10 min, DustMembresSync) ; un rôle changé ou un
// membre retiré ici serait remplacé sans prévenir. Les comptes se gèrent dans les Réglages de l'app,
// onglet Comptes ; les membres des espaces restreints, dans les réglages de chaque espace.
export const MENU_MEMBRES = "members";

export function menusAdministrationVisibles<T extends { id: string }>(
  menus: T[]
): T[] {
  return menus.filter((m) => m.id !== MENU_MEMBRES);
}
